import { supabase } from '@/lib/supabase'
import { createAdminTrialRequest } from './adminTrialRequest'

export const postAdminTrialAction = createAdminTrialRequest(async () => {
  const { data, error } = await supabase.auth.getSession()
  if (error) throw new Error('Unable to read your admin session. Please sign in again.')
  return data.session?.access_token ?? null
})
